module.exports = __webpack_public_path__ + "static/media/russia.5350d488.webp";